import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";
import { userFullName } from "helpers/common";
import PDFHtmlRenderer from "./PDFHtmlRenderer";
import { useSelector } from "react-redux";

const styles = StyleSheet.create({
  mainHeading: {
    fontSize: 10,
    fontWeight: 'semibold',
    fontFamily: 'Proxima Nova',
  },
  border: {
    borderBottom: "1px solid #000",
    paddingBottom: "2px",
    marginBottom: "8px"
  },
  mainSubHeading: {
    fontSize: 8,
    fontWeight: 'semibold',
    fontFamily: 'Proxima Nova',
    letterSpacing: "1px",
    textTransform: "uppercase"
  },
});

const TherapistSignaturePdf = ({ data }) => {
  console.log('signature data', data)
  return (
    <View>
      {
        data?.apprentice &&
        <View style={{ gap: "2px", marginTop: "20px", marginBottom: "20px" }}>
          <>
            <View>
              {/* <Image style={styles.logo} src={data?.apprenticeSignature} /> */}
              {
                data?.caseApprentice?.caseTherapist?.therapist_detail?.signature_img &&
                <Image style={{ width: "50%" }} src={data?.caseApprentice?.caseTherapist?.therapist_detail?.signature_img} />
              }
            </View>
            <Text style={{ fontSize: 8 }}>{userFullName(data?.caseApprentice?.caseTherapist)}</Text>
            <Text style={{ fontSize: 8 }}>Student</Text>
          </>
        </View>
      }
      {
        data?.therapist?.role_type == "veteran" &&
        <View style={{ gap: "1px" }}>
          <View>
            {
              data?.therapistSignature &&
              <Image style={{ width: "50%" }} src={data?.therapistSignature} />
            }
          </View>
          {/* <Text style={{ fontSize: 8 }}>{data?.emailSignature}</Text> */}
          <PDFHtmlRenderer
            style={{ fontSize: 8 }}
            stylesheet={{
              p: { marginBottom: 0, marginTop: 0 },
            }}
            data={data?.emailSignature}
          />
          {/* <Text style={{ fontSize: 8 }}>{`Clinician Supervisor`}</Text>
        <Text style={{ fontSize: 8, color: "#315D99", textDecoration: "underline" }}>{data?.therapist?.email}</Text>
        <Text style={{ fontSize: 8 }}>{data?.therapist?.phone}</Text> */}
        </View>
      }
    </View>
  )
}

export default TherapistSignaturePdf;